export const actionTypes = {
    GET_ASSET_KPI_TREND_LIST: 'assetConditionInsights/GET_ASSET_KPI_TREND_LIST',
    LOAD_ASSET_KPI_TREND_LIST: 'assetConditionInsights/LOAD_ASSET_KPI_TREND_LIST',
    ADD_SELECTED_TREND_KPI_DATA: 'assetConditionInsights/ADD_SELECTED_TREND_KPI_DATA',
    ZOOM_IN_TO_SELECTED_TREND_KPI_DATA: 'assetConditionInsights/ZOOM_IN_TO_SELECTED_TREND_KPI_DATA',
    RELOAD_CONDITION_INSIGHTS: 'assetConditionInsights/RELOAD_CONDITION_INSIGHTS',
    SET_CONDITION_INSIGHTS_ZOOM: 'assetConditionInsights/SET_CONDITION_INSIGHTS_ZOOM',
    RELOAD_CONDITION_INSIGHTS_SUCCESS: 'assetConditionInsights/RELOAD_CONDITION_INSIGHTS_SUCCESS',
    SET_CONDITION_INSIGHTS_ZOOM_SUCCESS: 'assetConditionInsights/SET_CONDITION_INSIGHTS_ZOOM_SUCCESS',
    CLEAR_STORE: 'assetConditionInsights/CLEAR_STORE',
    SET_ACTIVE_CONDITION_INSIGHTS_TAB: 'assetConditionInsights/SET_ACTIVE_CONDITION_INSIGHTS_TAB',
    GET_RETRAINING_PROGRESS: 'assetConditionInsights/GET_RETRAINING_PROGRESS',
    TRIGGER_RETRAINING: 'assetConditionInsights/TRIGGER_RETRAINING',
    GET_RETRAINING_PROGRESS_SUCCESS: 'assetConditionInsights/GET_RETRAINING_PROGRESS_SUCCESS',
    GET_RETRAINING_PROGRESS_ERROR: 'assetConditionInsights/GET_RETRAINING_PROGRESS_ERROR',
    SET_DRIVE_ANOMALY_ACTIVE_TAB: 'assetConditionInsights/SET_DRIVE_ANOMALY_ACTIVE_TAB',
    SET_KPI_FROM_SUMMARY_TAB: 'assetConditionInsights/SET_KPI_FROM_SUMMARY_TAB',
    TOGGLE_CONDITION_FORECAST: 'assetConditionInsights/TOGGLE_CONDITION_FORECAST'
};

export const DRIVE_STATUS_KEY = 'DriveStatus';

export const ANOMALY_DETECTION_KEY = 'Anomaly_MotorAnomalyDetection';

export const DRIVE_ANOMALY_DETECTION_KEY = 'Anomaly_DriveCoolingAnomalyInference';

export const ACS1000_COOLING_ANOMALY_KEY = 'Anomaly_MvDriveCoolingAnomalyDetection';

export const ENERGY_ANOMALY_DETECTION_KEY = 'Anomaly_EnergyOutlierDetection';

export const driveAnomalyTabs = {
    COOLING: 'cooling',
    ENERGY: 'energy'
};

export const EMAIL_SUB_TAB_ANOMALY = 'anomaly';

export const OVER_ALL_STATUS = {
    Poor: 3,
    Tolerable: 2,
    Good: 1,
    Unknown: 0,
};

export const KPI_TYPE = {
    Threshold: 'Threshold',
    LongTerm: 'LongTerm',
    ShortTerm: 'ShortTerm',
    DcVoltage: 'DcVoltage',
};

export const chartHeightConstants = {
    default: 700,
    min: 510,
    max: 1500,
    reserved: 40
};

export const MACHSENSOR = 'MACHsense-R';
